import { Navigate, Outlet } from 'react-router-dom';
import { roleHasAccess, type UserRole } from '@rosita/shared';
import { useAuthStore } from '../../stores/authStore';

interface Props {
  roles: UserRole[];
}

export function RequireRole({ roles }: Props): JSX.Element {
  const { user, isLoading } = useAuthStore();
  if (isLoading) return <div style={{ padding: 24 }}>A carregar…</div>;
  if (!user) return <Navigate to="/conta/login" replace />;
  const allowed = roles.some((r) => roleHasAccess(user.role, r));
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
